import {DataObjectAssignmentType, MaterialOutputType} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"
import {DataObjectAssignmentType as SharedDataObjectAssignmentType} from "@cm/utils/data-object-assignment"
import {MATERIAL_THUMBNAIL_DIMENSIONS} from "@cm/utils/material-thumbnail-constants"

export type FlatOption = {
    size: number
    resolution: number
    dataObjectAssignmentType:
        | DataObjectAssignmentType.MaterialThumbnail_10x10
        | DataObjectAssignmentType.MaterialThumbnail_15x15
        | DataObjectAssignmentType.MaterialThumbnail_20x20
        | DataObjectAssignmentType.MaterialThumbnail_30x30
        | DataObjectAssignmentType.MaterialThumbnail_7x7Inches
        | DataObjectAssignmentType.MaterialThumbnail_9x9Inches
        | DataObjectAssignmentType.MaterialThumbnail_16x16Inches
        | DataObjectAssignmentType.MaterialThumbnail_8x8Inches
        | DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches
        | DataObjectAssignmentType.MaterialThumbnail_27x27Inches
        | DataObjectAssignmentType.MaterialThumbnail_32x32Inches
    materialOutputType:
        | MaterialOutputType.Thumbnail10x10cm
        | MaterialOutputType.Thumbnail15x15cm
        | MaterialOutputType.Thumbnail20x20cm
        | MaterialOutputType.Thumbnail30x30cm
        | MaterialOutputType.Thumbnail7x7inches
        | MaterialOutputType.Thumbnail9x9inches
        | MaterialOutputType.Thumbnail16x16inches
        | MaterialOutputType.Thumbnail8x8inches
        | MaterialOutputType.Thumbnail13_5x13_5inches
        | MaterialOutputType.Thumbnail27x27inches
        | MaterialOutputType.Thumbnail32x32inches
}

export const FlatThumbnailOptionLabels = new Map<MaterialOutputType, StateLabel<FlatOption>>([
    [
        MaterialOutputType.Thumbnail10x10cm,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_10x10],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_10x10,
                materialOutputType: MaterialOutputType.Thumbnail10x10cm,
            },
            label: "10cm x 10cm",
        },
    ],
    [
        MaterialOutputType.Thumbnail15x15cm,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_15x15],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_15x15,
                materialOutputType: MaterialOutputType.Thumbnail15x15cm,
            },
            label: "15cm x 15cm",
        },
    ],
    [
        MaterialOutputType.Thumbnail20x20cm,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_20x20],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_20x20,
                materialOutputType: MaterialOutputType.Thumbnail20x20cm,
            },
            label: "20cm x 20cm",
        },
    ],
    [
        MaterialOutputType.Thumbnail30x30cm,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_30x30],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_30x30,
                materialOutputType: MaterialOutputType.Thumbnail30x30cm,
            },
            label: "30cm x 30cm",
        },
    ],
    [
        MaterialOutputType.Thumbnail7x7inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_7x7Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
                materialOutputType: MaterialOutputType.Thumbnail7x7inches,
            },
            label: "7in x 7in",
        },
    ],
    [
        MaterialOutputType.Thumbnail8x8inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_8x8Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
                materialOutputType: MaterialOutputType.Thumbnail8x8inches,
            },
            label: "8in x 8in",
        },
    ],
    [
        MaterialOutputType.Thumbnail9x9inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_9x9Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
                materialOutputType: MaterialOutputType.Thumbnail9x9inches,
            },
            label: "9in x 9in",
        },
    ],
    [
        MaterialOutputType.Thumbnail13_5x13_5inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
                materialOutputType: MaterialOutputType.Thumbnail13_5x13_5inches,
            },
            label: "13.5in x 13.5in",
        },
    ],
    [
        MaterialOutputType.Thumbnail16x16inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_16x16Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
                materialOutputType: MaterialOutputType.Thumbnail16x16inches,
            },
            label: "16in x 16in",
        },
    ],
    [
        MaterialOutputType.Thumbnail27x27inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_27x27Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
                materialOutputType: MaterialOutputType.Thumbnail27x27inches,
            },
            label: "27in x 27in",
        },
    ],
    [
        MaterialOutputType.Thumbnail32x32inches,
        {
            state: {
                ...MATERIAL_THUMBNAIL_DIMENSIONS[SharedDataObjectAssignmentType.MaterialThumbnail_32x32Inches],
                dataObjectAssignmentType: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
                materialOutputType: MaterialOutputType.Thumbnail32x32inches,
            },
            label: "32in x 32in",
        },
    ],
])
